export const fiscalAssessmentDocumentGroupsKind = {
  activity: 'Notas de Serviços',
  piece: 'Notas de Peças',
}
